
import { Prop, Vue, Component } from 'vue-property-decorator';
import CategoryTree from './CategoryTree.vue';
import PriceFilter from './PriceFilter.vue';
import BrandFilter from './BrandFilter.vue';
import SizeFilter from './SizeFilter.vue';

interface FilterItem {
    name: string;
    count: number;
}

@Component({
    components: {
        CategoryTree,
        PriceFilter,
        BrandFilter,
        SizeFilter
    }
})
export default class FilterProduct extends Vue {
    @Prop({ required: true }) readonly categories!: any[];
    @Prop({ required: true }) readonly brands!: FilterItem[];
    @Prop({ required: true }) readonly sizes!: FilterItem[];

    priceRange: { min: string; max: string } = { min: '', max: '' };
    selectedBrands: string[] = [];
    selectedSizes: string[] = [];
}
